<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">Tag Details</h4>
            <v-simple-table v-if="$route.params.id != 0">
              <tbody>
                <tr>
                  <td>Tag Name</td>
                  <td>
                    {{ tagModel.name ? tagModel.name : "" }}
                  </td>
                </tr>
                <tr>
                  <td>Tag Id</td>
                  <td>
                    {{ tagModel.id ? tagModel.id : "" }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-btn
              v-if="$route.params.id == 0"
              color="primary"
              large
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Create a New Tag</v-btn
            >
            <v-btn
              v-else
              large
              color="primary"
              :to="`${$route.path}/edit`"
              class="mr-2"
              >Edit</v-btn
            >
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { Tag } from "@/models/Tag";
import { gql } from "apollo-boost";
export default {
  data() {
    return {
      isEdit: false,
      tagModel: new Tag(),
      me: "",
      search: null,
      crumbs: [
        {
          text: "Tags",
          disabled: false,
          href: "/admin/tags",
        },
        {
          text: "Tag Details",
          disabled: false,
          href: `/admin/tags/${this.$route.params.id}`,
        },
      ],
    };
  },
  created() {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    tag: {
      query: gql`
        query Tag($id: ID!) {
          tag(id: $id) {
            id
            name
            createdBy
            createdAt
            updatedAt
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.$route.params.id || this.$route.params.id == 0;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
          createdBy: self.me.id,
        };
      },
      watchLoading(isLoading) {
        this.isLoading = isLoading;
      },
      result(response, key) {
        this.isLoading = false;
        this.tagModel.id = this.tag.id;
        this.tagModel.name = this.tag.name;
        this.tagModel.createdBy = this.tag.createdBy;
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
